import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withModifiers as _withModifiers, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-4 col-sm-6" }
const _hoisted_5 = {
  key: 0,
  class: "form-group mb-4"
}
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "input-error" }
const _hoisted_8 = { class: "col-lg-4 col-sm-6" }
const _hoisted_9 = { class: "form-group mb-4" }
const _hoisted_10 = {
  class: "vue3-select-custom-container",
  style: {"position":"relative","width":"100%"}
}
const _hoisted_11 = { class: "input-error mt-1" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-lg-8 col-sm-6" }
const _hoisted_14 = { class: "form-group mb-4" }
const _hoisted_15 = {
  key: 0,
  class: "input-error"
}
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-lg-8 col-sm-6" }
const _hoisted_18 = { class: "form-group mb-4" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-lg-8 col-sm-6" }
const _hoisted_21 = { class: "form-group mb-4" }
const _hoisted_22 = {
  key: 0,
  class: "input-error"
}
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-lg-4 col-sm-6" }
const _hoisted_25 = {
  key: 0,
  class: "form-group mb-4"
}
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "input-error" }
const _hoisted_28 = { class: "col-lg-4 col-sm-6" }
const _hoisted_29 = { class: "form-group mb-4" }
const _hoisted_30 = { class: "input-error" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-lg-4 col-sm-6" }
const _hoisted_33 = { class: "form-group mb-4" }
const _hoisted_34 = { class: "input-error" }
const _hoisted_35 = { class: "col-lg-4 col-sm-6" }
const _hoisted_36 = { class: "form-group mb-4" }
const _hoisted_37 = { class: "input-error" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-lg-12" }
const _hoisted_40 = { class: "form-group mb-4" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = ["src"]
const _hoisted_43 = { class: "input-error" }
const _hoisted_44 = { class: "col-lg-12" }
const _hoisted_45 = { class: "d-flex flex-wrap gap-3" }
const _hoisted_46 = ["disabled"]
const _hoisted_47 = { key: 0 }
const _hoisted_48 = {
  key: 1,
  class: "spinner-border spinner-border-sm me-2",
  "aria-hidden": "true"
}
const _hoisted_49 = {
  key: 2,
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_FilePond = _resolveComponent("FilePond")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[20] || (_cache[20] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.validateForm && _ctx.validateForm(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.itemsCompany)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _cache[22] || (_cache[22] = _createElementVNode("label", { class: "label text-secondary" }, "Empresa/Institución", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select form-control h-45",
                    "aria-label": "Default select example",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.team.companyId) = $event)),
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearError('companyId')))
                  }, [
                    _cache[21] || (_cache[21] = _createElementVNode("option", { value: null }, "-- Seleccionar --", -1 /* HOISTED */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsCompany, (company, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: company.id,
                        key: i
                      }, _toDisplayString(company.name), 9 /* TEXT, PROPS */, _hoisted_6))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                    [_vModelSelect, _ctx.team.companyId]
                  ]),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.errors.companyId), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[23] || (_cache[23] = _createElementVNode("label", { class: "label text-secondary mb-2" }, "Torneos", -1 /* HOISTED */)),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.team.tournamentIds,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.team.tournamentIds) = $event)),
                  mode: "tags",
                  placeholder: "-- Seleccionar --",
                  options: 
                    _ctx.itemsTournament.map((t) => ({ value: t.id, label: t.name }))
                  ,
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearError('tournamentIds')))
                }, null, 8 /* PROPS */, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.errors.tournamentIds), 1 /* TEXT */)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _cache[24] || (_cache[24] = _createElementVNode("label", { class: "label text-secondary" }, "Nombre", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control h-45",
                placeholder: "Ingresar el nombre del equipo",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.team.name) = $event)),
                onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.clearError('name')))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [
                  _vModelText,
                  _ctx.team.name,
                  void 0,
                  { trim: true }
                ]
              ]),
              (_ctx.errors.name)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.errors.name), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _cache[25] || (_cache[25] = _createElementVNode("label", { class: "label text-secondary" }, "Descripción", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("textarea", {
                rows: "4",
                style: {"resize":"none"},
                class: "form-control text-dark no-resize",
                placeholder: "Ingresar la descripción del equipo",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.team.description) = $event)),
                onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.clearError('description')))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [
                  _vModelText,
                  _ctx.team.description,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createCommentVNode("    <div v-if=\"errors.description\" class=\"input-error\">\r\n                {{ errors.description }}\r\n              </div> ")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _cache[26] || (_cache[26] = _createElementVNode("label", { class: "label text-secondary" }, "Nombre del apoderado/gerente (opcional)", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control h-45",
                placeholder: "Ingresar el nombre del apoderado/gerente",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.team.managerName) = $event)),
                onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.clearError('managerName')))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [
                  _vModelText,
                  _ctx.team.managerName,
                  void 0,
                  { trim: true }
                ]
              ]),
              (_ctx.errors.managerName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.errors.managerName), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            (_ctx.itemsDocumentType)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _cache[28] || (_cache[28] = _createElementVNode("label", { class: "label text-secondary" }, "Tipo documento (opcional)", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select form-control h-45",
                    "aria-label": "Default select example",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.team.documentTypeId) = $event)),
                    onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.clearError('documentTypeId')))
                  }, [
                    _cache[27] || (_cache[27] = _createElementVNode("option", { value: null }, "-- Seleccionar --", -1 /* HOISTED */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsDocumentType, (documentType, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: documentType.id,
                        key: i
                      }, _toDisplayString(documentType.name), 9 /* TEXT, PROPS */, _hoisted_26))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                    [_vModelSelect, _ctx.team.documentTypeId]
                  ]),
                  _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.errors.documentTypeId), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _cache[29] || (_cache[29] = _createElementVNode("label", { class: "label text-secondary" }, "Documento de identidad (opcional)", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control h-45",
                placeholder: "Ingresar el username",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.team.documentNumber) = $event)),
                onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.clearError('documentNumber')))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [
                  _vModelText,
                  _ctx.team.documentNumber,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.errors.documentNumber), 1 /* TEXT */)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _cache[30] || (_cache[30] = _createElementVNode("label", { class: "label text-secondary" }, "Correo contacto (gestor de cuenta) (opcional)", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control h-45",
                placeholder: "Ingresar el correo electrónico del contacto",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.team.contactEmail) = $event)),
                onInput: _cache[15] || (_cache[15] = ($event: any) => (_ctx.clearError('contactEmail')))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [
                  _vModelText,
                  _ctx.team.contactEmail,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.errors.contactEmail), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _cache[31] || (_cache[31] = _createElementVNode("label", { class: "label text-secondary" }, "Teléfono/Celular (opcional)", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control h-45",
                placeholder: "Ingresar el Teléfono/Celular",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.team.phoneNumber) = $event)),
                onInput: _cache[17] || (_cache[17] = ($event: any) => (_ctx.clearError('phoneNumber')))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [
                  _vModelText,
                  _ctx.team.phoneNumber,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.errors.phoneNumber), 1 /* TEXT */)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _cache[32] || (_cache[32] = _createElementVNode("label", { class: "label text-secondary" }, "Portada", -1 /* HOISTED */)),
              (_ctx.team.urlPhoto)
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    _createElementVNode("img", {
                      src: _ctx.team.urlPhoto,
                      alt: "Portada de Equipo",
                      class: "img-fluid mb-2 d-block"
                    }, null, 8 /* PROPS */, _hoisted_42),
                    _createElementVNode("button", {
                      onClick: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removePhotoFile && _ctx.removePhotoFile(...args)), ["prevent"])),
                      class: "btn btn-danger"
                    }, " Eliminar portada ")
                  ]))
                : _createCommentVNode("v-if", true),
              (!_ctx.team.urlPhoto)
                ? (_openBlock(), _createBlock(_component_FilePond, {
                    key: 1,
                    name: "photo",
                    maxFileSize: '2MB',
                    "accepted-file-types": _ctx.supportedFormats,
                    "allow-multiple": "false",
                    "max-files": 1,
                    "label-idle": "Arrastra tu imagen o <span class='filepond--label-action'>Buscar</span>",
                    labelMaxFileSizeExceeded: 'El archivo es demasiado grande',
                    labelMaxFileSize: 'El tamaño máximo permitido es {filesize}',
                    labelFileTypeNotAllowed: 'El archivo tiene una extensión no permitida',
                    fileValidateTypeLabelExpectedTypes: `Los tipos de archivo permitidos son: ${_ctx.supportedFormats.join(
                  ', '
                )}`,
                    credits: "",
                    onUpdatefiles: _ctx.handleUpdateFiles,
                    onInput: _cache[19] || (_cache[19] = ($event: any) => (_ctx.clearError('photo')))
                  }, null, 8 /* PROPS */, ["accepted-file-types", "fileValidateTypeLabelExpectedTypes", "onUpdatefiles"]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.errors.photo), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createVNode(_component_RouterLink, { to: "/teams" }, {
                default: _withCtx(() => _cache[33] || (_cache[33] = [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-danger bg-danger bg-opacity-10 text-danger border-0 fw-semibold py-2 px-4"
                  }, " Cancelar ", -1 /* HOISTED */)
                ])),
                _: 1 /* STABLE */
              }),
              _createElementVNode("button", {
                class: "btn btn-primary bg-primary bg-opacity-10 text-primary border-0 fw-semibold py-2 px-4",
                type: "submit",
                disabled: _ctx.isLoading
              }, [
                (!_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(_ctx.team.id == 0 ? "Crear Equipo" : "Actualizar Equipo"), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_48))
                  : _createCommentVNode("v-if", true),
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_49, "Procesando..."))
                  : _createCommentVNode("v-if", true)
              ], 8 /* PROPS */, _hoisted_46)
            ])
          ])
        ])
      ], 32 /* NEED_HYDRATION */)
    ])
  ]))
}